<template>
    <td class="content-type-cell">
        {{title}}
    </td>
</template>
<script>
import TableCellMixin from './TableCellMixin.js';

export default {
    mixins: [TableCellMixin],
    data() {
        return {
            glossary:null,
        }
    },
    async created() {
        const glossary = await this.$sdk.content.glossary({hash:true});
        this.glossary = glossary;
    },
    computed: {
        match() {
            return this.glossary ? this.glossary[this.value] : null;
        },
        title() {
            return this.match?.title || this.value;
        },
    }
}
</script>
<style lang="scss" scoped>
.content-type-cell {
    white-space: nowrap;
}

</style>
